// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qa-5";
export var filledCircle = "_qa-4";
export var historyEntry = "_qa-3";
export var messageSideLeft = "_qa-1";
export var messageSideRight = "_qa-2";
export var orderTrackingCarouselWrapper = "_qa-6";
export var orderTrackingInfoContainer = "_qa-0";